<div class="container kh-title-text w-100 parent">
    <div class="row settings-row kh-medium-text desktop-only">
        <div class="col-lg-3 col-md-4 col-sm-12">
            <div class="kh-lg-title-text kh-text-primary">
                {{label}}
            </div>
        </div>
        <div class="col-lg-6 col-md-5 col-sm-12 d-flex align-items-center preserve-line-breaks" [class.ellipsis]="!isEditing" [attr.data-testid]="testId">
            <ng-container *ngIf="!isEditing; else editSettingFormDesktop">
                <ng-container *ngIf="value">
                  {{value}}
                </ng-container>
                <ng-container *ngIf="valueList">
                  <ul class="value-list">
                    <li class="mb-kh-2" *ngFor="let item of valueList">
                      {{item}}
                    </li>
                  </ul>
                </ng-container>
            </ng-container>
        </div>
        <div class="col-md-3 col-sm-12 d-flex align-items-center justify-content-end" *ngIf="isEditable">
            <ng-container *ngIf="!isEditing">
                <ng-content select="[customContent]"></ng-content>
            </ng-container>
            <button khA11yActionButton type="button" [khA11yLabel]="!editButtonLabel ? ('SETTINGS_VALUE.EDIT_SETTING' | translate: { setting: label }) : null" class="kh-button-reset pointer" *ngIf="!isEditing; else saveButton" (click)="toggleEditing()">
                <div *ngIf="!editButtonLabel" class="edit-button-container d-flex align-items-center justify-content-center" data-testid="edit-button">
                    <svg khA11yHidden focusable="false" [ngStyle]="{fill: editColor}" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.2969 8.44685L16.4833 2.70162L18.3984 0.786549C18.9228 0.262183 19.5671 0 20.3313 0C21.0946 0 21.7384 0.262183 22.2628 0.786549L24.1778 2.70162C24.7022 3.22599 24.9758 3.85888 24.9986 4.60028C25.0214 5.34078 24.7706 5.97321 24.2462 6.49758L22.2969 8.44685ZM1.36791 24.9644C0.980336 24.9644 0.655686 24.8331 0.393959 24.5704C0.13132 24.3087 0 23.984 0 23.5965V19.7321C0 19.5497 0.0341978 19.3733 0.102593 19.2027C0.170989 19.0313 0.273582 18.8772 0.410373 18.7404L14.4999 4.6509L20.3135 10.4645L6.224 24.554C6.0872 24.6908 5.93354 24.7934 5.76301 24.8618C5.59156 24.9302 5.41465 24.9644 5.23226 24.9644H1.36791Z"></path>
                    </svg>
                </div>
                <div *ngIf="editButtonLabel" class="d-flex align-items-center justify-content-center">
                    {{editButtonLabel}}
                </div>
            </button>
        </div>
    </div>

    <!-- Mobile -->
    <div class="row settings-row kh-medium-text mobile-only">
        <div class="{{isEditing ? 'col-12' : 'col-9'}} d-flex align-items-left justify-content-center flex-column">
            <div class="kh-medium-title-text kh-text-primary">
                {{label}}
            </div>
            <div [class.ellipsis]="!isEditing">
              <ng-container *ngIf="!isEditing; else editSettingFormMobile">
                <ng-container *ngIf="value">
                  {{value}}
                </ng-container>
                <ng-container *ngIf="valueList">
                  <ul class="value-list">
                    <li class="mb-kh-2" *ngFor="let item of valueList">
                      {{item}}
                    </li>
                  </ul>
                </ng-container>
            </ng-container>
            </div>
        </div>
        <ng-container *ngIf="!isEditing">
            <ng-content select="[customContent]"></ng-content>
        </ng-container>
        <div class="{{isEditing ? 'col-12' : 'col-3'}} d-flex align-items-center justify-content-end" *ngIf="isEditable">
            <button khA11yActionButton type="button" [khA11yLabel]="!editButtonLabel ? ('SETTINGS_VALUE.EDIT_SETTING' | translate: { setting: label }) : null" class="kh-button-reset pointer" *ngIf="!isEditing; else saveButton" (click)="toggleEditing()">
                <div *ngIf="!editButtonLabel" class="edit-button-container d-flex align-items-center justify-content-center" data-testid="edit-button">
                    <svg khA11yHidden focusable="false" [ngStyle]="{fill: editColor}" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.2969 8.44685L16.4833 2.70162L18.3984 0.786549C18.9228 0.262183 19.5671 0 20.3313 0C21.0946 0 21.7384 0.262183 22.2628 0.786549L24.1778 2.70162C24.7022 3.22599 24.9758 3.85888 24.9986 4.60028C25.0214 5.34078 24.7706 5.97321 24.2462 6.49758L22.2969 8.44685ZM1.36791 24.9644C0.980336 24.9644 0.655686 24.8331 0.393959 24.5704C0.13132 24.3087 0 23.984 0 23.5965V19.7321C0 19.5497 0.0341978 19.3733 0.102593 19.2027C0.170989 19.0313 0.273582 18.8772 0.410373 18.7404L14.4999 4.6509L20.3135 10.4645L6.224 24.554C6.0872 24.6908 5.93354 24.7934 5.76301 24.8618C5.59156 24.9302 5.41465 24.9644 5.23226 24.9644H1.36791Z"></path>
                    </svg>
                </div>
                <div *ngIf="editButtonLabel" class="d-flex align-items-center justify-content-center">{{editButtonLabel}}
                    <span class="pl-kh-2">
                        <svg khA11yHidden focusable="false" [ngStyle]="{fill: editColor}" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.45372e-05 11.5128C0.000484255 11.2456 0.0629002 10.9821 0.182413 10.743C0.301926 10.504 0.475274 10.296 0.688819 10.1353L4.64116 7.13661C4.72859 7.07862 4.8003 6.99989 4.84992 6.90745C4.89953 6.815 4.92549 6.71172 4.92549 6.60681C4.92549 6.50189 4.89953 6.39861 4.84992 6.30617C4.8003 6.21372 4.72859 6.13499 4.64116 6.077L0.688819 3.13129C0.475056 2.96842 0.301717 2.75846 0.182267 2.51772C0.0628175 2.27698 0.000472253 2.01195 7.45372e-05 1.7432C-0.00293019 1.41974 0.0849646 1.10193 0.253749 0.825973C0.422533 0.550017 0.665421 0.327007 0.954751 0.182342C1.24408 0.0376774 1.56822 -0.0228276 1.89026 0.00771872C2.21229 0.0382651 2.51928 0.158635 2.77625 0.355119L7.7564 4.10613C8.14321 4.40296 8.45656 4.78479 8.6722 5.22209C8.88784 5.65938 9 6.14042 9 6.628C9 7.11557 8.88784 7.59661 8.6722 8.03391C8.45656 8.4712 8.14321 8.85303 7.7564 9.14987L2.77625 12.9009C2.51928 13.0974 2.21229 13.2177 1.89026 13.2483C1.56822 13.2788 1.24408 13.2183 0.954751 13.0737C0.665421 12.929 0.422533 12.706 0.253749 12.43C0.0849646 12.1541 -0.00293019 11.8363 7.45372e-05 11.5128Z"></path>
                        </svg>
                    </span>
                </div>
            </button>
        </div>
    </div>
</div>

<ng-template #saveButton>
    <div class="settings-button-container">
        <button khA11yActionButton (click)="saveClicked()" class="kh-primary-button kh-medium-text settings-button" *ngIf="!hideSaveButton" [disabled]="disableSaveButton" data-testid="save-button">{{ 'SETTINGS_VALUE.SAVE' | translate }}</button>
        <div class="d-block w-kh-2"></div>
        <button khA11yActionButton class="kh-button-reset text-link link-lg text-link-secondary" (click)="cancelClicked()" data-testid="cancel-button">{{ 'SETTINGS_VALUE.CANCEL' | translate }}</button>
    </div>
</ng-template>

<ng-template #editSettingFormDesktop>
    <ng-content select="[formSectionDesktop]"></ng-content>
</ng-template>
<ng-template #editSettingFormMobile>
    <ng-content select="[formSectionMobile]"></ng-content>
</ng-template>